export enum Apis {
  TRAINING = 'training'
}

export enum ApiVersion{
  V1 = 'v1'
}
